import { inject } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { AuthService }  from "../auth/auth.service";
import { DevicesService } from '../../features/bots/devices.service';

export const DeviceGuard: CanActivateFn = async() => {

  const deviceService =  inject(DevicesService);
  
  deviceService.fetchDevices();

  return true;
}
